// Shared react-tooltip anchor attributes. Prefer these over the HTML `title`
// attribute for hover hints: `title` only shows on desktop hover and is
// invisible on touch devices, whereas react-tooltip shows on mobile taps too.
// Binds to the single <Tooltip id="hw-tooltip"/> mounted in View.
export const HW_TOOLTIP_ID = "hw-tooltip";

export function tooltipProps(content?: string) {
  return content
    ? {
        "data-tooltip-id": HW_TOOLTIP_ID,
        "data-tooltip-content": content,
      }
    : {};
}
